import { Component } from '@angular/core';
import { CommonService } from '@core/services/common-service/common.service';
import { GlobalConstants } from '@environments/global-Variables';
import { Column } from '@shared/models/column-interface';
import { ITab } from '@shared/models/tab-interface';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { TableRecord } from '../ui-components/table/table.component';

@Component({
  selector: 'weaccess-person-detail-modal',
  templateUrl: './person-detail-modal.component.html',
  styleUrls: ['./person-detail-modal.component.scss']
})
export class PersonDetailModalComponent {
  globalConstants = GlobalConstants;
  employeeDetails: any;

  requestTableData: Array<TableRecord> = [];
  departmentTableData: Array<TableRecord> = [];
  jobTableData: Array<TableRecord> = [];
  managerData: Array<TableRecord> = [];
  systemAccessTableData: Array<TableRecord> = [];

  /** Request Table Column list  */
  requestTableColumns: Array<Column> = [
    {
      columnDef: 'actionTaken',
      header: 'Last Action Taken',
      cell: (element: Record<string, any>) => `${element['actionTaken']}`
    },
    {
      columnDef: 'workflowState',
      header: 'Current Workflow State',
      cell: (element: Record<string, any>) => `${element['workflowState']}`,
    },
    {
      columnDef: 'statusDate',
      header: 'Status Date',
      cell: (element: Record<string, any>) => `${element['statusDate']}`
    },
    {
      columnDef: 'modifiedBy',
      header: 'Modified By',
      cell: (element: Record<string, any>) => `${element['modifiedBy']}`
    }

  ];

  /** Department Table Column list */
  departmentTableColumns: Array<Column> = [
    {
      columnDef: 'departmentName',
      header: 'Department Name',
      cell: (element: Record<string, any>) => `${element['departmentName']}`
    },
    {
      columnDef: 'startDate',
      header: 'Start Date',
      cell: (element: Record<string, any>) => `${element['startDate']}`,
    },
    {
      columnDef: 'endDate',
      header: 'End Date',
      cell: (element: Record<string, any>) => `${element['endDate']}`
    },
    {
      columnDef: 'approvedBy',
      header: 'Approved By',
      cell: (element: Record<string, any>) => `${element['approvedBy']}`
    }
  ];

  /** Manager Table Column list */
  managerTableColumns: Array<Column> = [
    {
      columnDef: 'managerName',
      header: 'Manager Name',
      cell: (element: Record<string, any>) => `${element['managerName']}`
    },
    {
      columnDef: 'startDate',
      header: 'Start Date',
      cell: (element: Record<string, any>) => `${element['startDate']}`,
    },
    {
      columnDef: 'endDate',
      header: 'End Date',
      cell: (element: Record<string, any>) => `${element['endDate']}`
    },
    {
      columnDef: 'approvedBy',
      header: 'Approved By',
      cell: (element: Record<string, any>) => `${element['approvedBy']}`
    }
  ];

  /** Job Table Column list */
  jobTableColumns: Array<Column> = [
    {
      columnDef: 'jobTitle',
      header: 'Job Title',
      cell: (element: Record<string, any>) => `${element['jobTitle']}`
    },
    {
      columnDef: 'startDate',
      header: 'Start Date',
      cell: (element: Record<string, any>) => `${element['startDate']}`,
    },
    {
      columnDef: 'endDate',
      header: 'End Date',
      cell: (element: Record<string, any>) => `${element['endDate']}`
    },
    {
      columnDef: 'approvedBy',
      header: 'Approved By',
      cell: (element: Record<string, any>) => `${element['approvedBy']}`
    }
  ];

  /** System Access Table */
  systemAccessTableColumns: Array<Column> = [
    {
      columnDef: 'appName',
      header: 'System Access',
      cell: (element: Record<string, any>) => `${element['appName']}`
    },
    {
      columnDef: 'currentStatus',
      header: 'Current Status',
      cell: (element: Record<string, any>) => `${element['currentStatus']}`
    },
    {
      columnDef: 'statusDate',
      header: 'Status Date',
      cell: (element: Record<string, any>) => `${element['statusDate']}`
    },

    {
      columnDef: 'requestType',
      header: 'Request Type',
      cell: (element: Record<string, any>) => `${element['requestType']}`
    },
    {
      columnDef: 'modifiedBy',
      header: 'Modified By',
      cell: (element: Record<string, any>) => `${element['modifiedBy']}`
    }
  ];

  requestDataSubscription!: Subscription;
  departmentDataSubscription!: Subscription;
  jobDataSubscription!: Subscription;
  managerDataSubscription!: Subscription;
  systemDataSubscription!: Subscription;

  /**  Tabs configuration */
  tabs: ITab[] = [
    { title: 'Details', content: 'details', active: true, disabled: false },
    { title: 'History', content: 'history', disabled: false },
    { title: 'System Access', content: 'systemAccess', disabled: false },
  ];

  constructor(
    private bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private commonService: CommonService,
  ) {
    this.employeeDetails = this.modalService?.config?.initialState;
    this.employeeDetails = this.employeeDetails?.data;
  }

  ngOnInit() { }

  ngOnChanges() {
    if (this.employeeDetails) {
      this.tabs[0].active = true;
    }
  }

  /** Close button click event functionality */
  onClose() {
    this.bsModalRef.hide();
  }

  /** Get active tab data based on user selection */
  getTabData(activeTab: any) {
    let personReqParam = {
      personId: 0,
    }

    let accessReqParam = {
      personOrDraftId: 0,
      historyType: this.globalConstants?.TYPE_PEOPLE
    }
    if (activeTab === this.globalConstants?.HISTORY) {
      this.requestDataSubscription = this.commonService.getRequestData(accessReqParam).subscribe((requestHistoryData: any) => {
        this.requestTableData = requestHistoryData;
      });
      this.departmentDataSubscription = this.commonService.getDepartmentHistoryData(personReqParam).subscribe((deptHistoryData: any) => {
        this.departmentTableData = deptHistoryData;
      });
      this.jobDataSubscription = this.commonService.getJobDetailData(personReqParam).subscribe((jobHistoryData: any) => {
        this.jobTableData = jobHistoryData;
      });
      this.managerDataSubscription = this.commonService.getManagerData(personReqParam).subscribe((managerHistoryData: any) => {
        this.managerData = managerHistoryData;
      });
    } else if (activeTab === this.globalConstants?.SYSTEM_ACCESS) {
      this.systemDataSubscription = this.commonService.getSystemAccessData(personReqParam).subscribe((systemHistoryData: any) => {
        this.systemAccessTableData = systemHistoryData;
      });
    }
  }

  /** Track by function for ngFor in Tab module */
  trackByFn1(index: number, tabz: any): number {
    return tabz.id;
  }

  /** Track by function for ngFor in Person Details module */
  trackByFn2(index: number, persondetail: any): number {
    return persondetail.id;
  }

  ngOnDestroy() {
    this.requestDataSubscription?.unsubscribe();
    this.departmentDataSubscription?.unsubscribe();
    this.jobDataSubscription?.unsubscribe();
    this.managerDataSubscription?.unsubscribe();
    this.systemDataSubscription?.unsubscribe();
  }
}
